import { useEffect, useState, type FC } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import TitleUF from "../atoms/typography/TitleUF";
import { HorizontalSpacer } from "../atoms/Spacers";
import Lookup from "../organisms/Lookup";
import { userManager } from "../../auth/oidcConfig";

/*
const NewsCardsContainer = styled.div`
  display: flex;
  gap: 32px;
`;

const exampleTasks = [
  {
    id: "123",
    task: "Skicka ut julklappar till alla Enterprisekunder",
    dueDate: "2024-12-15",
    assignedTo: {
      id: "userId1",
      firstName: "Betina Andersson",
    },
    organisationNumber: undefined,
    created: "2025-11-20",
    assignedBy: undefined,
    sharedWith: [],
    isCompleted: false,
    url: undefined,
  },
  {
    id: "124",
    task: "Följ upp offert till Kund AB",
    dueDate: "2024-11-30",
    assignedTo: {
      id: "userId2",
      firstName: "Erik Svensson",
    },
    organisationNumber: "556677-8899",
    created: "2024-11-01",
    assignedBy: {
      id: "userId3",
      firstName: "Anna Karlsson",
    },
    sharedWith: [
      {
        id: "userId4",
        firstName: "Lena Nilsson",
      },
    ],
    isCompleted: false,
    url: undefined,
  },
];*/

const HomePage: FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [user, setUser] = useState<any>(null);

  const getUser = async () => {
    await userManager.getUser().then((user) => {
      if (user) {
        setUser(user?.profile);
      }
    });
  };
  /*
  const {
    internalCompanyNews,
    error: newsError,
    loading: newsLoading,
  } = useInternalCompanyNews();
*/
  useEffect(() => {
    getUser();
  }, []);

  const onClickLookupItem = (item: {
    clientIdentifier: string;
    clientType: string;
    companyName: string;
  }) => {
    navigate(`/client/${item.clientIdentifier}`);
  };

  return (
    <div>
      <TitleUF>
        {t("startPage.welcome")} {user?.name}!
      </TitleUF>
      <HorizontalSpacer spacing={3} />
      <Lookup type="dropdown" onClickResult={onClickLookupItem} />

      <HorizontalSpacer spacing={2} />

      {/*
      <Row>
        <Col lg={7}>
          <Card spacing={2}>
            <Subheading color={theme.colors.primary}>
              Nyheter och meddelanden
            </Subheading>
            <HorizontalSpacer spacing={1} />
            <NewsCardsContainer>
              {newsLoading && <LoadingSpinner />}
              {internalCompanyNews?.items?.map((newsItem, index) => (
                <NewsCard
                  key={newsItem._id}
                  title={newsItem.title}
                  date={newsItem.sys.firstPublishedAt}
                  content={newsItem.content}
                  imageUrl={newsItem.image?.url}
                  index={index}
                />
              ))}
              {newsError && (
                <Alert type="error" title="Kunde inte ladda nyheter" />
              )}
            </NewsCardsContainer>
          </Card>
        </Col>
        <Col lg={5}>
          <Card>
            <Row align="center" nogutter justify="between">
              <Subheading color={theme.colors.primary}>
                Mina uppgifter
              </Subheading>
              <OutlinedButton
                title="Skapa ny"
                icon={<AddIcon color={theme.colors.primary} />}
                color={theme.colors.primary}
                medium
              />
            </Row>
            <HorizontalSpacer spacing={1} />
            {exampleTasks.map((task) => (
              <div
                style={{
                  display: "flex",
                  gap: 16,
                  padding: 8,
                  borderBottom: `1px solid ${theme.colors.grey3}`,
                  alignItems: "center",
                }}
                key={task.id}
              >
                <Checkbox checked={task.isCompleted} />
                <div style={{ width: "100%" }}>
                  <div style={{ display: "flex", gap: 32 }}>
                    <BodySmall color={theme.colors.textSecondary}>
                      Skapad: {dayjs(task.created).format("YYYY-MM-DD")}
                    </BodySmall>
                    <BodySmall color={theme.colors.textSecondary}>
                      Slutdatum:{" "}
                      {task.dueDate
                        ? dayjs(task.created).format("YYYY-MM-DD")
                        : "Ej angivet"}
                    </BodySmall>
                  </div>
                  {task.assignedBy && (
                    <BodySmall color={theme.colors.textSecondary}>
                      Tilldelad av: {task.assignedBy.firstName}
                    </BodySmall>
                  )}
                  <Body>{task.task}</Body>

                  {task.sharedWith.length > 0 &&
                    task.sharedWith.map((user) => (
                      <BodySmall
                        key={user.id}
                        color={theme.colors.textSecondary}
                      >
                        Delas med: {user.firstName}
                      </BodySmall>
                    ))}
                  {task.organisationNumber && (
                    <TextLinkButton
                      title="Till klientkortet"
                      onClick={() =>
                        navigate(`/client/${task.organisationNumber}`)
                      }
                      color={theme.colors.textSecondary}
                    />
                  )}
                </div>
                <div style={{ display: "flex", gap: 16 }}>
                  <DeleteModal
                    deleteButtonType="circleButton"
                    onClickDelete={() => console.log("delete")}
                  />
                  <CircleButton
                    icon={<EditIcon color={theme.colors.text} />}
                    onClick={() => console.log("edit")}
                  />
                </div>
              </div>
            ))}
            <HorizontalSpacer spacing={1} />
            <Row justify="end" nogutter>
              <TextLinkButton
                title="Visa slutförda"
                onClick={() => console.log("display more")}
                color={theme.colors.primary}
              />
            </Row>
          </Card>
        </Col>
      </Row>*/}
    </div>
  );
};

export default HomePage;
